export default {"src":"/_next/static/media/redditWhite.fb208bd0.svg","height":594,"width":666};